import axios from "axios";
import { BASE_URL } from "../configs/api";

// Single logout path for the whole app: revokes the tokens server-side
// (access-token denylist + refresh-token removal), then clears local state.
// Always clears storage even if the server call fails, so the user is
// never stuck on a dead session.
export const serverLogout = async () => {
  try {
    const stored = localStorage.getItem("accessToken");
    const tokenData = stored ? JSON.parse(stored) : null;
    if (tokenData?.accessToken) {
      await axios.post(
        `${BASE_URL}Auth/logout`,
        { refreshToken: tokenData?.refreshToken },
        { headers: { Authorization: `Bearer ${tokenData.accessToken}` } }
      );
    }
  } catch (error) {
    console.error("Logout request failed:", error);
  } finally {
    localStorage.clear();
  }
};

// For callers that navigate via react-router
export const logoutAndNavigate = async (navigate) => {
  await serverLogout();
  navigate("/");
};

// For non-component contexts (interceptors, utils) — hard redirect
export const logoutAndRedirect = async (urlPath = "/") => {
  await serverLogout();
  window.location.replace(urlPath);
};
